// MAIN VIEWS
export const MARKET = 'market';
export const MARKETS = 'markets';
export const CREATE_MARKET = 'create-market';
export const ACCOUNT_SUMMARY = 'account-summary';
export const REPORTING = 'reporting';
export const DISPUTING = 'disputing';
export const TRANSACTIONS = 'transactions';
export const MY_POSITIONS = 'portfolio';
export const MIGRATE_REP = 'migrate-rep';
export const LANDING_PAGE = 'explore';

export const DEFAULT_VIEW = MARKETS;
